import React from 'react';

const containerStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'stretch',
  backgroundColor: '#F2B407',
  border: '2px solid #4A4A4A',
  borderRadius: 5,
  overflow: 'visible',
  boxShadow: '0 2px 6px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.15)',
};

const sizeStyles: Record<'small' | 'middle' | 'large', React.CSSProperties> = {
  small: {
    padding: '1px 6px',
    fontSize: 12,
    letterSpacing: 1,
  },
  middle: {
    padding: '3px 12px 3px 10px',
    fontSize: 18,
    letterSpacing: 2,
  },
  large: {
    padding: '5px 16px',
    fontSize: 22,
    letterSpacing: 2.5,
  },
};

const baseTextStyle: React.CSSProperties = {
  fontFamily: '"UK Number Plate", "Charles Wright", monospace',
  fontWeight: 700,
  color: '#000000',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
};

interface RegPlateProps {
  children: React.ReactNode;
  size?: 'small' | 'middle' | 'large';
}

export const RegPlate: React.FC<RegPlateProps> = ({ children, size = 'middle' }) => (
  <div style={containerStyle}>
    <div style={{ ...baseTextStyle, ...sizeStyles[size] }}>{children}</div>
  </div>
);
